<!-- 
GroupNewModal.vue
功能：成立新的群組視窗
作者：i9400538 陳博承
完成：2021-05-26
-->
<template>
  <div id="group-new-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="text-green m-0 mt-1">成立新的群組</h3>
        </div>
        <div class="div-padding">
          <div class="row mt-2 mb-4">
            <div class="col-12">
              <span v-if="custName" class="cust-name">
                請新增&nbsp;
                <span class="text-green">{{custName}}</span> 想加入的群組
              </span>
              <span v-else class="cust-name">請新增該客戶想加入的群組</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div v-for="(group, i) in newGroups" :key="`new-group-${type}-${i}`">
                <table>
                  <tr>
                    <td>
                      <span class="no">{{i + 1}}.</span>
                    </td>
                    <td>
                      <div class="input">
                        <input
                          type="text"
                          size="50"
                          maxlength="20"
                          :id="`group-name-${i}`"
                          :data-vv-name="`group-name-${i}`"
                          v-model="group.grp_name"
                          v-validate="'required|checkName|checkIsDuap|checkIsDuap2'"
                          placeholder="請輸入群組名稱"
                          data-vv-as="群組名稱"
                          :class="{ 'is-invalid': errors.has(`group-name-${i}`) }"
                          class="form-control"
                          alt="ch"
                          @input="checkInputName(group)"
                          @blur="checkInputName(group)"
                        />
                      </div>
                    </td>
                    <td>
                      <a v-if="i > 0" @click="doRemove(i)" class="btn btn-default delete-btn">刪除</a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="col-10 offset-1 text-center">
            <a role="button" type="button" class="btn btn-default" @click="doAdd">
              <i class="icon-add_new"></i>
              <span class="text">再新增一筆</span>
            </a>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="$emit('close')" class="btn btn-default">取消</a>
                <a @click="doSave" class="btn btn-primary">儲存</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" content="資料儲存中，請稍候..." />
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { Validator } from "vee-validate";
//service
import { createGroupsByCust } from "@/service";
//component
import mxMask from "@/desktop/components/mxMask";

export default {
  name: "GroupNewModal",
  mixins: [commonMixin],
  components: {
    mxMask
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custName: {
      type: String,
      dafault: ""
    },
    allGroup: {
      type: Array
    },
    selectedGroup: {
      type: Array
    },
    type: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: ""
    }
  },
  watch: {
    selectedGroup: function() {
      this.registerHanlink();
    },
    unselectedGroup: function() {
      this.registerHanlink();
    },
    newGroups: function() {
      this.registerHanlink();
    },
    open: function(val) {
      if (val == true) {
        this.allGroups = [...this.allGroup];
        this.newGroups = [{ grp_name: "" }];
        this.groupCount = this.selectedGroup
          ? 10 - this.selectedGroup.length
          : 10;
        this.initValidator();
      }
    }
  },
  data() {
    return {
      allGroups: [],
      newGroups: [],
      groupCount: 10,
      mxMaskOpen: false
    };
  },
  methods: {
    //新增一筆群組
    doAdd() {
      if (this.newGroups.length >= this.groupCount) {
        this.$toast.info({ title: "每個人不可超過10個群組" });
        return;
      }
      let group = {
        grp_name: ""
      };
      this.newGroups.push(group);
    },
    //刪除群組
    doRemove(index) {
      this.newGroups.splice(index, 1);
    },
    //檢查輸入群組名稱
    checkInputName(group) {
      group.grp_name = this.cleanSpecialChar(group.grp_name, '@()_');
      if (this.stringBytes(group.grp_name, false, 40) > 40) {
        group.grp_name = group.grp_name.substring(
          0,
          this.stringBytes(group.grp_name, true, 40)
        );
      }
    },
    //儲存
    doSave() {
      if (this.groupCount <= 0) {
        this.$toast.info({ title: "每個人不可超過10個群組" });
        return;
      }

      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        //通過檢查
        this.mxMaskOpen = true;
        createGroupsByCust(
          this.$store.state.userInfo.id,
          this.$store.state.userInfo.id,
          this.source && this.source == "CustomerCreate"
            ? "CRM"
            : this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo,
          this.source,
          this.newGroups
        ).then(result => {
          this.mxMaskOpen = false;
          if (result.header.status && result.header.status == "200") {
            this.$emit("submit", result.body.result);
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      });
    },
    //檢核初始化，加入檢核規則
    initValidator() {
      this.$validator.reset();
      //檢查群組名稱不可為空
      Validator.extend("checkName", {
        getMessage: "請輸入群組名稱",
        validate: value => {
          let isNonEmpty = value.trim().length > 0;
          return isNonEmpty;
        }
      });
      //檢查新增群組名稱是否與業務員底下的所有群組名稱有重複
      Validator.extend("checkIsDuap", {
        getMessage: "此群組名稱已經存在",
        validate: value => {
          let cnt = 0;
          for (let i = 0; i < this.allGroups.length; i++) {
            if (value == this.allGroups[i].grp_name) {
              cnt++;
            }
          }
          return cnt < 1;
        }
      });
      //檢查新增群組之間有無重複
      Validator.extend("checkIsDuap2", {
        getMessage: "群組名稱重複輸入",
        validate: value => {
          let cnt = 0;
          for (let i = 0; i < this.newGroups.length; i++) {
            if (value == this.newGroups[i].grp_name) {
              cnt++;
            }
          }
          return cnt < 2;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.div-padding {
  padding: 20px 40px;
}
.cust-name {
  font-size: 18px;
  font-weight: 600;
}
</style>